<template>
    <AppSection  class="section-popular-directions">
        <template #header_left v-if="params.header_left">
            <div v-html="params.header_left"></div>
        </template>
        <template #header_right v-if="params.header_right">
            <div v-html="params.header_right"></div>
        </template>
        <template #body>
            <slider-cards v-if="params.items" nav :params="{slidesPerView: 1,pagination: true,}">
                <swiper-slide v-for="(item, i) in params.items" :key="i">
                    <PromotionCard :data="item" :theme-color="item.color"/>
                </swiper-slide>
            </slider-cards>
        </template>
    </AppSection>
</template>

<script>
import AppSection from "../AppSection";
import SliderCards from "../SliderCards";
import { SwiperSlide } from 'swiper/vue';
import PromotionCard from "../cards/PromotionCard";

export default {
    name: "PromotionSection",
    props: {
        params: {
            type: Object,
            default: () => ({
                message: {},
                items: []
            })
        },
    },
    components: {PromotionCard, SliderCards, AppSection, SwiperSlide},
}
</script>

<style scoped>

</style>